import { ReactNode, useState } from 'react';
import {
  EntityLifecyclePicker,
  EntityOwnerPicker,
  EntityProcessingStatusPicker,
  EntitySearchBar,
  EntityTagPicker,
  EntityTypePicker,
  UserListPicker,
} from '@backstage/plugin-catalog-react';
import { Box, Button, Collapse, makeStyles } from '@material-ui/core';
import { TierPicker } from './TierPicker';

const useStyles = makeStyles({
  search: {
    flex: 1,
    minWidth: 240,
    // the search bar's toolbar, then its form control
    '& > div': { width: '100%', paddingLeft: 0, paddingRight: 0 },
    '& > div > div': { width: '100%' },
  },
});

const MoreFilters = ({ open }: { open: boolean }) => (
  <Collapse in={open}>
    <Box display="flex" flexWrap="wrap" mt={1} style={{ gap: 16 }}>
      <Box minWidth={200}>
        <UserListPicker />
      </Box>
      <Box minWidth={200}>
        <EntityLifecyclePicker />
      </Box>
      <Box minWidth={200}>
        <EntityTagPicker />
      </Box>
      <Box minWidth={200}>
        <EntityProcessingStatusPicker />
      </Box>
    </Box>
  </Collapse>
);

/** One row: search, the three filters people use, and the page actions. The rest is one click away. */
export const FilterBar = ({ actions }: { actions: ReactNode }) => {
  const classes = useStyles();
  const [showMore, setShowMore] = useState(false);

  return (
    <Box mb={2}>
      <Box
        display="flex"
        alignItems="flex-end"
        flexWrap="wrap"
        style={{ gap: 16 }}
      >
        <Box className={classes.search}>
          <EntitySearchBar />
        </Box>
        <Box minWidth={200}>
          <EntityOwnerPicker />
        </Box>
        <Box minWidth={160}>
          <TierPicker />
        </Box>
        <Box minWidth={160}>
          <EntityTypePicker />
        </Box>
        <Box style={{ paddingBottom: 21 }}>
          <Button size="small" onClick={() => setShowMore(!showMore)}>
            {showMore ? 'Fewer filters' : 'More filters'}
          </Button>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          style={{ gap: 8, paddingBottom: 21 }}
        >
          {actions}
        </Box>
      </Box>
      <MoreFilters open={showMore} />
    </Box>
  );
};
